import { Events } from 'src/graphql/schema.graphql';
import { gql, GqlFragment } from 'src/utils/gql/query';

export const eventsSitemapGqlQuery: GqlFragment<{ events: Events[] }> = gql`
  query EventsSitemapList {
    events(filter: { status: { _eq: "published" } }, limit: -1) {
      slug
      date_created
      date_updated
    }
  }
`;
